/**
 * Phone/tablet app mode: signed in (Layout sets <html data-app>) and narrower than lg, the same
 * test as index.css's `app:` variant. Screen transitions and the settle-in animation run only
 * here; the website (desktop, or signed out) changes pages instantly. Read at call time, never
 * during render, so pre-rendered pages stay server-safe.
 */
export function isAppMode() {
  return (
    typeof window !== 'undefined' &&
    window.matchMedia('(width < 64rem)').matches &&
    document.documentElement.hasAttribute('data-app')
  );
}
